// extracted by mini-css-extract-plugin
export default {"recos":"Y4-z","productCardOverride":"Z4-z","rowHasBadge":"_4-z"};